const translation = {
  routesGroup: {
    home: '首页',
    iaas: 'IaaS',
    containerService: '容器服务',
    ai: '人工智能',
    others: '其他',
    systemSetting: '网站设置',
  },
  // routes title keys
  userCenter: '个人中心',
  market: '算力市场',
  modelSquare: '模型广场',
  trialCenter: '体验中心',
  dashboard: '仪表盘',
  compute: '计算',
  instancesAndImages: '实例与镜像',
  vm: '虚拟机',
  baremetal: '裸金属',
  instanceGroup: '主机组',
  serverTemplate: '主机模板',
  scalingGroup: '弹性伸缩组',
  webApp: '应用程序服务',
  systemImage: '系统镜像',
  hostImage: '主机镜像',
  storageAndBackup: '存储与备份',
  disk: '硬盘',
  diskSnapshot: '硬盘快照',
  instanceSnapshot: '主机快照',
  snapshotPolicy: '自动快照策略',
  diskBackup: '硬盘备份',
  instanceBackup: '主机备份',
  networkAndSecurity: '网络与安全',
  secGroup: '安全组',
  subnet: 'IP子网',
  eip: '弹性公网IP',
  tapService: '流量镜像',
  keypair: '密钥',
  resourceAndSchedule: '资源与调度',
  sku: '套餐',
  host: '宿主机',
  physicalMachine: '物理机',
  gpu: '透传设备',
  schedTag: '调度标签',
  schedPolicy: '调度策略',
  dynamicSchedTag: '动态调度标签',
  recycleBin: '回收站',
  serverRecovery: '虚拟机',
  diskRecovery: '硬盘',
  imageRecovery: '镜像',
  network: '网络',
  networkPlan: '网络规划',
  region: '区域',
  zone: '可用区',
  baseNetwork: '基础网络',
  vpcInterconnect: 'VPC互联',
  vpcPeer: 'VPC对等连接',
  globalVpc: '全局VPC',
  vpc: 'VPC',
  routeTable: '路由表',
  wire: '二层网络',
  networkService: '网络服务',
  nat: 'NAT网关',
  dns: 'DNS解析',
  ipv6: 'IPv6网关',
  networkSecurity: '网络安全',
  waf: 'WAF策略',
  sshProxy: 'SSH代理服务',
  sshProxyNode: 'SSH代理节点',
  sshProxyService: 'SSH代理服务',
  lb: '负载均衡',
  lbInstance: '实例',
  lbAcl: '访问控制',
  lbCert: '证书',
  lbCluster: '负载均衡集群',
  lbClusterMain: '集群',
  lbClusterNode: '节点',
  cdn: '内容分发网络',
  cdnDomain: 'CDN域名',
  storage: '存储',
  blockStorage: '块存储',
  workload: '工作负载',
  stateless: '无状态',
  stateful: '有状态',
  daemonset: '守护进程',
  job: '任务',
  cronjob: '定时任务',
  pod: '容器组',
  pvc: '存储声明',
  imageRepo: '镜像仓库',
  serviceDiscovery: '服务发现',
  service: '服务',
  ingress: '路由',
  configManage: '配置管理',
  configmap: '配置项',
  secret: '保密字典',
  clusterManage: '集群管理',
  node: '节点',
  storageClass: '存储类',
  namespace: '命名空间',
  role: '角色',
  clusterRole: '集群角色',
  roleBinding: '角色绑定',
  clusterRoleBinding: '集群角色绑定',
  serviceAccount: '服务账户',
  kubeComponent: '服务组件',
  federatedCluster: '联邦集群',
  federatedNamespace: '命名空间',
  federatedRole: '角色',
  federatedClusterRole: '集群角色',
  federatedRoleBinding: '角色绑定',
  federatedClusterRoleBinding: '集群角色绑定',
  ml: '机器学习',
  maasServiceNav: '模型服务',
  aiMarket: 'AI市场',
  computeMarket: '算力市场',
  modelMarket: '模型广场',
  experienceCenter: '体验中心',
  trainAndInference: '训练 & 推理',
  devMachine: '开发机',
  trainTask: '训练任务',
  trainTemplate: '训练模版',
  inferenceService: '推理服务',
  aiAssets: 'AI资产',
  dataset: '数据集',
  modelManage: '模型管理',
  containerImage: '容器镜像',
  repository: '镜像仓库',
  diskStorage: '磁盘存储',
  resourceQuota: '资源配额',
  resourceMonitor: '资源监控',
  resourceAudit: '资源审计',
  modelService: '模型服务',
  modelMarketGroup: '模型广场',
  modelServiceGroup: '模型服务',
  modelServiceSettingGroup: '系统设置',
  usageStatistics: '用量统计',
  serviceList: '服务价格',
  apiKey: 'API Key',
  systemSetting: '系统设置',
  serviceSetting: '服务设置',
  modelServicePrices: '模型服务价格',
  apiKeyMgmt: 'API Key 管理',
  computeCluster: '计算集群',
  resourceDashboard: '资源大盘',
  storageCluster: '存储集群',
  modelServiceSetting: '模型服务',
  // 保留旧的翻译以防其他地方使用
  dataManage: '数据管理',
  containerInstance: '容器实例',
  modelList: '模型列表',
  modelTrain: '模型训练',
  modelInference: '模型推理',
  auditLog: '审计日志',
  aiAppBuild: 'AI应用构建',
  knowledgeBase: '知识库',
  appBuild: '应用构建',
  appMarket: '应用市场',
  monitoringAndOperations: '监控与运维',
  overview: '总览',
  resource: '资源',
  monitorVM: '虚拟机',
  monitorHost: '宿主机',
  monitorMetric: '监控指标',
  monitorDashboard: '监控面板',
  monitorQuery: '监控查询',
  alert: '告警',
  alertPolicy: '告警策略',
  alertHistory: '告警历史',
  alertResource: '告警资源',
  alertPolicy2: '告警策略',
  authenticationAndSecurity: '认证与安全',
  authSystem: '认证体系',
  authIdp: '认证域',
  authDomain: '域',
  authProject: '项目',
  authGroup: '组',
  authUser: '用户',
  authRole: '角色',
  authPolicy: '权限',
  securityAlert: '安全告警',
  messageCenter: '消息中心',
  messageSubscribeSetting: '消息订阅设置',
  notifyChannelSetting: '通知渠道设置',
  contactManage: '接收人管理',
  robotManage: '机器人管理',
  systemSetting2: '系统设置',
  websiteSetting: '网站设置',
  licenseSetting: 'License 设置',
}
export default translation
